import "./object-info.scss";
import { useEffect } from "react";
import dayjs from "dayjs";
import { TableInfoType, TableInfo } from "@/features/table-info";
import { ObjectQueriesTags } from "@entities/api/object";
import { generateConstructionTypeName, useObject } from "@entities/object";
import { useCoordinator } from "@shared/lib/hooks";
import { queryClient } from "@shared/lib/react-query";
import { useNavigate, routes } from "@shared/lib/react-router";
import { ObjectInfoOpinion } from "../object-info-opinion";
import { ObjectInfoPermission } from "../object-info-permission";

export const ObjectInfo = () => {
  const navigate = useNavigate();
  const { projectId, objectId } = useCoordinator();
  const { data: object, isLoading } = useObject({ objectId });
  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: ObjectQueriesTags.getObject({ objectId }),
    });
  }, [objectId]);
  const tableMock: TableInfoType[] = [
    {
      id: 1,
      title: "Краткое наименование объекта",
      info: object.shortName || "-",
    },
    {
      id: 2,
      title: "Вид строительства",
      info:
        generateConstructionTypeName(object.constructionType as string) || "-",
    },
    {
      id: 3,
      title: "Наименование объекта капитального строительства",
      info: object.fullName || "-",
    },
    {
      id: 4,
      title: "Краткие проектные характеристики",
      info: object.descriptionProjects || "-",
    },
    {
      id: 5,
      title: "Описание этапа строительства, реконструкции",
      info: object.descriptionStage || "-",
    },
    {
      id: 6,
      title:
        // @ts-expect-error addressType отсутствует в openapi типе адреса объекта
        object.address.addressType === "CONSTRUCTION"
          ? "Строительный адрес"
          : "Почтовый адрес",
      info: object.address.addressString || "",
    },
    {
      id: 7,
      title: "Начало строительства",
      info: object.buildingStart
        ? dayjs(object.buildingStart).format("DD.MM.YYYY")
        : "-",
    },
    {
      id: 8,
      title: "Окончание строительства",
      info: object.buildingEnd
        ? dayjs(object.buildingEnd).format("DD.MM.YYYY")
        : "-",
    },
  ];

  return (
    <>
      <TableInfo
        tabs={tableMock}
        name="Информация об объекте строительства"
        isButton
        handleIsButton={() =>
          navigate(routes.objects.edit(projectId, objectId))
        }
        businessEntity="object"
        buttonName="Редактировать"
        isLoading={isLoading}
      />
      <ObjectInfoPermission data={object.documentationPermissions} />
      <ObjectInfoOpinion data={object.documentationExaminations} />
    </>
  );
};
